import axios from 'axios'
import React, {  Fragment } from 'react'
import Avatar from '@components/avatar'
import { toast, Slide } from 'react-toastify'
import { AlertCircle } from 'react-feather'
import config from '@src/configs/themeConfig'

const ErrorToastContent = ({ title, content }) => (
  <Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <Avatar size='sm' color='danger' icon={<AlertCircle size={12} />} />
        <h6 className='toast-title font-weight-bold'>{title}</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span>{content}</span>
    </div>
  </Fragment>
)

function upper(obj) {
  for (const prop in obj) {
  if (typeof obj[prop] === 'string') {
    obj[prop] = obj[prop].toUpperCase()
  }
  if (typeof obj[prop] === 'object') {
    upper(obj[prop])
    }
  }
  return obj
}

function cleanJson(data) {
  // if (typeof data === 'object') {
  //   const _data = {}
  //   Object.keys(data).forEach(key => {
  //     if (data[key] === '' || data[key] === undefined) {
  //       console.log('no entra')
  //     } else {
  //       _data[key] = data[key]
  //     }
  //   })
  //   return _data
  // } else {
    return data
  // }
}

// const accessToken = localStorage.getItem('accessToken')
const instance = axios.create({
  baseURL: config.app.baseUrl,
  transformRequest: [
    (data, headers) => {
      console.log(headers)
      // if (data) {
      //   data = upper(data)
      // }
      return data
    }, 
    ...axios.defaults.transformRequest
  ]
})

Tawk_API = Tawk_API || {}
Tawk_API.onLoad = function() {
  Tawk_API.setAttributes(JSON.parse((localStorage.getItem('rememberMe') === 'true' ? localStorage : sessionStorage).getItem('userData')), function(error) {
    console.log(error)
  })
  setInterval(() => {
    Tawk_API.setAttributes(JSON.parse((localStorage.getItem('rememberMe') === 'true' ? localStorage : sessionStorage).getItem('userData')), function(error) {
      console.log(error)
    })
  }, 5000)
}

const getStorage = () => (localStorage.getItem('rememberMe') === 'true' ? localStorage : sessionStorage)

const getTokenPair = (data) => ({
  accessToken: data?.accessToken || data?.access?.token,
  refreshToken: data?.refreshToken || data?.refresh?.token
})

instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  const tester = new RegExp(/victimas|apoyos|asistenciaInmediata|audiencia|servicioInterno|fichaInformativa|erogacion|fuds|event/g)
  if (tester.test(config.url)) config.data = cleanJson(upper(config.data))
  if (config.data && config.data.case) config.data.case = config.data.case.toLowerCase()
  // Always read the latest token from storage on each request
  const token = getStorage().getItem('accessToken')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})

// No-op for callers that previously triggered a manual header refresh.
// The request interceptor now reads the token from storage on every call.
instance.refresh = () => {}

// Proactive session expiry check on tab focus
let _visibilityListenerAttached = false
if (!_visibilityListenerAttached && typeof document !== 'undefined') {
  _visibilityListenerAttached = true
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return
    try {
      const storage = getStorage()
      const accessToken = storage.getItem('accessToken')
      const refreshToken = storage.getItem('refreshToken')
      if (!accessToken || !refreshToken) return
      const aParts = accessToken.split('.')
      const rParts = refreshToken.split('.')
      if (aParts.length !== 3 || rParts.length !== 3) return
      const aExp = JSON.parse(atob(aParts[1])).exp
      const rExp = JSON.parse(atob(rParts[1])).exp
      if (Date.now() >= aExp * 1000 && Date.now() >= rExp * 1000) {
        window.location.pathname = '/login'
      }
    } catch (_) {
      // malformed token or storage unavailable — silently ignore
    }
  })
}

// Token refresh state — prevents concurrent refresh requests
let isRefreshing = false
let refreshSubscribers = []

const notifySubscribers = (token) => {
  refreshSubscribers.forEach(cb => cb(token))
  refreshSubscribers = []
}

instance.interceptors.response.use((response) => {
  return response
}, async (err) => {
  const originalRequest = err.config

  if (err.response?.data?.code === 401 && !originalRequest._retry) {
    originalRequest._retry = true

    if (!isRefreshing) {
      isRefreshing = true
      const storage = getStorage()
      const refreshToken = storage.getItem('refreshToken')

      try {
        const { data } = await axios.post(`${config.app.baseUrl}/auth/refresh-tokens`, { refreshToken })
        const tokenPair = getTokenPair(data)
        if (!tokenPair.accessToken || !tokenPair.refreshToken) throw new Error('Invalid refresh token response')
        storage.setItem('accessToken', tokenPair.accessToken)
        storage.setItem('refreshToken', tokenPair.refreshToken)
        isRefreshing = false
        notifySubscribers(tokenPair.accessToken)
        originalRequest.headers.Authorization = `Bearer ${tokenPair.accessToken}`
        return instance(originalRequest)
      } catch (_refreshErr) {
        isRefreshing = false
        refreshSubscribers = []
        window.location.pathname = '/login'
        return Promise.reject(err)
      }
    }

    // Another request already started a refresh — queue and retry when done
    return new Promise(resolve => {
      refreshSubscribers.push(token => {
        originalRequest.headers.Authorization = `Bearer ${token}`
        resolve(instance(originalRequest))
      })
    })
  }

  if (err.response?.data?.message) {
    toast.error(
      <ErrorToastContent title={'Error'} content={err.response.data.message} />,
      { transition: Slide, hideProgressBar: true, autoClose: 10000 }
    )
  }
  return Promise.reject(err)
})

export default instance